import { type FC, Suspense, useLayoutEffect } from 'react';
import { Outlet } from 'react-router';
import { appStarted } from '~/entities/auth';
import { initStore } from '~/shared/lib/storage';
import { ResponsiveModalsProvider } from '~/shared/ui/ResponsiveModals';
import { responsiveModalsMap } from '../../responsive-modals';
import { AppLoader } from './components';
import { useAuthQuerySync } from './lib';

export const BaseLayout: FC = () => {
    useAuthQuerySync();

    useLayoutEffect(() => {
        initStore().then(() => {
            appStarted();
        });
    }, []);

    return (
        <ResponsiveModalsProvider modals={responsiveModalsMap}>
            <Suspense fallback={<AppLoader />}>
                <Outlet />
            </Suspense>
        </ResponsiveModalsProvider>
    );
};
